/**
 * LoadingSpinner Component
 * 
 * Displays a spinning indicator while content is loading.
 */
import React from 'react';

interface LoadingSpinnerProps {
  /** Optional message to display below the spinner */
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message }) => {
  return (
    <div className="loading-container" data-testid="loading-spinner">
      <div>
        <div className="spinner" />
        {message && <p className="text-muted mt-2">{message}</p>}
      </div>
    </div>
  );
};

export default LoadingSpinner;

